import axios from "../service/axios/axios";

export default {
  //获取问诊记录列表
  consultList(data) {
    return axios({
      method: "post",
      url: "platform/consult/consultList",
      data: data,
    });
  },
  //查看记录详情、推送卫健委
  consultUploadItem({ consult_id }) {
    return axios({
      method: "post",
      url: "platform/consult/consultUploadItem",
      data: { consult_id },
    });
  },
  //查看记录详情
  consultItem({ consult_id }) {
    return axios({
      method: "post",
      url: "platform/consult/consultItem",
      data: { consult_id },
    });
  },
  //查看病情自述
  complainItem({ consult_id }) {
    return axios({
      method: "post",
      url: "platform/consult/complainItem",
      data: { consult_id },
    });
  },
  //查看问诊单
  inquiryItem({ inquiry_sheet_id, unique_key }) {
    return axios({
      method: "post",
      url: "platform/consult/inquiryItem",
      data: { inquiry_sheet_id, unique_key },
    });
  },
  //获取原始记录列表
  getMsgList(params) {
    return axios({
      method: "post",
      url: "platform/consult/getMsgList",
      data: params,
    });
  },
  //获取处方记录列表
  prescriptionList(data) {
    return axios({
      method: "post",
      url: "platform/prescription/prescriptionList",
      data: data,
    });
  },
  //查看处方记录详情
  prescriptionItem({ pre_id }) {
    return axios({
      method: "post",
      url: "platform/prescription/prescriptionItem",
      data: { pre_id },
    });
  },
  // 查看关联处方详情
  joinedPrescriptionItem(data) {
    return axios({
      method: "post",
      url: "platform/prescription/joinedPrescriptionItem",
      data: data,
    });
  },
  // 作废处方
  prescriptionCancel(data) {
    return axios({
      method: "post",
      url: "platform/prescription/cancel",
      data: data,
    });
  },
  // 查看是否缺药
  checkPrescriptionItem(data) {
    return axios({
      method: "post",
      url: "platform/prescription/checkPrescriptionItem",
      data: data,
    });
  },
  //病例记录列表
  casehistoryList(data) {
    return axios({
      method: "post",
      url: "platform/prescription/casehistoryList",
      data: data,
    });
  },

  //实体医疗机构病例
  patienthistorylist(data) {
    return axios({
      method: "post",
      url: "platform/prescription/patienthistorylist",
      data: data,
    });
  },

  //病例记录详情
  casehistoryItem({ pre_id }) {
    return axios({
      method: "post",
      url: "platform/prescription/casehistoryItem",
      data: { pre_id },
    });
  },
  //获取医生公告记录
  getNoticeList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getNoticeList",
      data: data,
    });
  },
  //获取患教文章记录
  getArticleList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getArticleList",
      data: data,
    });
  },
  /* 问诊记录 */
  //问诊记录退款
  refundConsult(data) {
    return axios({
      method: "post",
      url: "platform/Consult/refundConsult",
      data: data,
    });
  },
  //问诊费为零记录退款
  refundZeroConsult(data) {
    return axios({
      method: "post",
      url: "platform/consult/refundZeroConsult",
      data: data,
    });
  },
  // 设置处方是否显示金额
  setShowMoney(data) {
    return axios({
      method: "post",
      url: "platform/prescription/setShowMoney",
      data: data,
    });
  },
  // 病情证明打印信息
  getPrintPreInfo(data) {
    return axios({
      method: "post",
      url: "platform/prescription/getPrintPreInfo",
      data: data,
    });
  },
  // 保存拍方记录
  savePrescriptionPictureDraft(data) {
    return axios({
      method: "post",
      url: "platform/Photograph/savePrescriptionPictureDraft",
      data: data,
    });
  },
  // 读取拍方记录（开方草稿）
  getPrescriptionPictureDraft(data) {
    return axios({
      method: "post",
      url: "platform/Photograph/getPrescriptionPictureDraft",
      data: data,
    });
  },
  // 保存医生拍方（划价草稿）
  savePhotoPrescriptionDraft(data) {
    return axios({
      method: "post",
      url: "platform/Photograph/savePhotoPrescriptionDraft",
      data: data,
    });
  },
  // 读取医生拍方（划价草稿）
  getPhotoPrescriptionDraft(data) {
    return axios({
      method: "post",
      url: "platform/Photograph/getPhotoPrescriptionDraft",
      data: data,
    });
  },
  // 按方类目-主页配置详情
  agreementcategoryconfig(data) {
    return axios({
      method: "post",
      url: "/platform/photograph/agreementcategoryconfig",
      data: data,
    });
  },
  // 按方类目-主页配置修改
  agreementCategoryConfigEdit(data) {
    return axios({
      method: "post",
      url: "/platform/photograph/agreementCategoryConfigEdit",
      data: data,
    });
  },
  // 按方类目-养生方基础列表（供选择）
  agreementOintmentBase(data) {
    return axios({
      method: "post",
      url: "/platform/photograph/agreementOintmentBase",
      data: data,
    });
  },
  // 按方类目-协定方基础列表（供选择）
  agreementAgreeBase(data) {
    return axios({
      method: "post",
      url: "/platform/photograph/agreementAgreeBase",
      data: data,
    });
  },
};
